module.exports = __webpack_public_path__ + "img/SAFo_SocialMedia_Misinformation.0ed57341.svg";